// extracted by mini-css-extract-plugin
export default {"releaseBanner":"lMsN0","action":"gB9N6","arrow":"zBgzK","description":"NY4Zt","skeleton-progress":"zy-e-"};